import Image from "next/image";
import ActionIcon from "./action-icon";

const ButtonContent = ({ children, image, imagePosition, icon, ...rest }) => {
  // if (typeof children !== "string" && process.env.NODE_ENV !== "production") {
  //   throw new Error("ButtonContent only accepts a string as children.");
  // }

  const renderImageOrIcon = (position) => {
    if (icon) {
      return (
        <ActionIcon color="custom-text-grey-50">
          {icon}
        </ActionIcon>
      );
    }

    if (image) {
      const imageName = image.replace(image.split(".")[1], "").replace(".", "");
      const imageSrc = `/images/${image}`;
      return (
        <Image
          alt={imageName}
          src={imageSrc}
          height={100}
          width={100}
          className={position === 0 ? "h-[18px] w-[18px]" : "h-[18px] w-fit"}
        />
      );
    }

    return null;
  };

  return (
    <div className="flex items-center gap-[8px]">
      {imagePosition === 0 && renderImageOrIcon(0)}
      <span  className='!whitespace-nowrap' {...rest}>{children}</span>
      {imagePosition !== 0 && renderImageOrIcon(1)}
    </div>
  );
};

ButtonContent.defaultProps = {
  imagePosition: 1,
};

export default ButtonContent;
